export function formatEmojiId(code: string): string {
  try {
    // Split by underscore or space
    const codes = code.includes('_') ? code.split('_') : code.split(' ');

    return codes.map((c) => String.fromCodePoint(parseInt(c.replace('U+', ''), 16))).join('');
  } catch (error) {
    console.error('Failed to format emoji ID:', error);
    return '';
  }
}
